const Validator = {
    hasError(fields) {
        for (let fieldKey in fields) {
            if (fields[fieldKey].error || (fields[fieldKey].role.required && !fields[fieldKey].value)) {
                return true
            }
        }
        return false
    },
    reset(fields) {
        for (let fieldKey in fields) {
            fields[fieldKey].error = ''
        }
        return fields;
    },
    validate(fields) {
        for (let fieldKey in fields) {
            if (!fields[fieldKey].error && fields[fieldKey].role.required && !fields[fieldKey].value) {
                fields[fieldKey].error = 'Kötelező megadni'
            }
        }
        return {fields: fields, error: this.hasError(fields)}
    }
}
export default Validator


// WEBPACK FOOTER //
// ./src/components/common/Validator.js